<template>
  <div>
    <b-card class="mt-2 mb-0 smallinputs" :class="value.cssname" header-tag="header" footer-tag="footer"
      border-variant="success">
      <!-- {{ value }} -->

      <b-card-body class="mt-2 py-0 px-0 ">
        <b-tabs class="gridtabs" v-model="tabindex">

          <!-- <b-tab active :class="value.cssname == 'zhold_priced' ? 'zhold_priced' : null"> -->
          <b-tab active :class="value.cssname">
            <template #title>
              <i class="fa fa-handshake-o text-primary mr-2"></i><span class="strong">{{ value.slac }} | {{
                value.slacname
              }} | {{ value.eventcode }} | {{ value.eventname }}</span>
            </template>
            <!-- {{ value }}  -->
            <p class="py-3 px-0">
              <b-row>
                <b-col>
                  <div class="mt-0 mb-1 text-center">
                    <table class="w-100pct">
                      <tr class="header-dark mb-1">
                        <td role="columnheader" scope="col" aria-colindex="1"
                          class="table-b-table-default text-center w-25px">
                          <input style="height: 15px; margin-top: 2px" type="checkbox" :checked="true"
                            :disabled="true" />
                        </td>
                        <!-- colspan="2" -->
                        <td class="text-center w-50px">Grouping</td>
                        <td class="" style="width:25%">SL A/C</td>
                        <td class="" style="width:25%">Event</td>
                        <td class="text-right pr-2"> {{ zhold_type(value.cssname) }}</td>
                      </tr>
                      <tr>
                        <td class="w-30px pt-3px">
                          <b-input-group class="m-auto w-15px">
                            <input class="mt-5px" id="travellerCheck" style="height: 13px;" type="checkbox"
                              :checked="true" :value="true" :disabled="true" />
                          </b-input-group>
                        </td>
                        <td class="w-30px pt-5px"> <span class="small text-primary">{{ 0 + 1
                            }}.</span></td>
                        <!-- <td class="w-30px pt-5px"> <i class="fa fa-handshake-o text-primary mr-2"></i>
                        </td> -->
                        <td class="pt-3px">
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                                v-model="value.slac" :clearable="true" :multiple="false" :async="true"
                                :load-options="treeselect_loadSLAC" :show-count="true" :flatten-search-results="true"
                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                <div slot="value-label" slot-scope="{ node }">
                                  {{ node.raw.id }}
                                </div>
                              </treeselect>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td class="pt-3px">
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                                v-model="value.eventcode" :clearable="true" :multiple="false" :async="true"
                                :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested @select="treeselect">
                                <div slot="value-label" slot-scope="{ node }">
                                  {{ node.raw.id }}
                                </div>
                              </treeselect>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td></td>
                      </tr>
                    </table>
                  </div>

                  <!-- {{ mifields }} -->

                  <div class="my-0 mb-2">
                    <b-row align-v="start" class="" no-gutters v-if="mifields.length > 0">
                      <b-col cols="auto" class="text-right" style="width:74px">
                        <!-- <i class="fa fa-list text-primary" style="margin-top:24px; margin-right:8px;"> </i> -->
                      </b-col>
                      <!-- <b-col v-if="mifields.length == 0"> There are no fields to display</b-col> -->
                      <b-col class="px-2">
                        <b-row>
                          <b-col cols="12" sm="6" md="4" xl="3" v-for="(mifield, index) in mifields" :key="index">
                            <!-- <b-form-group :label="label(mifield)" label-cols="12" label-size="sm">-->
                            <b-form-group :label="$helpers.requiredlabel(requirement, mifield.label)" :class="$helpers
                              .requiredlabel(requirement, mifield.label)
                              .slice(0, 1) == '*'
                              ? 'text-danger'
                              : ''
                              " label-cols="12" label-size="sm">
                              <b-input-group>
                                <!-- :placeholder="placeholder(mifield)" :debounce="mifields.debounce" -->
                                <!-- v-model="mifields.args[mifield.key]"  -->
                                <b-form-input v-if="mifield.type == 'input'" type="text"
                                  :disabled="mifield.active == '0'" size="sm" trim v-model="mifield.value"
                                  :placeholder="mifield.label"></b-form-input>

                                <!-- v-if="mifield.clearable" @click="mifields.args[mifield.key] = null"-->
                                <b-input-group-append v-if="mifield.type == 'input'">
                                  <b-button size="sm" variant="outline-secondary" @click="mifield.value = ''">
                                    <i class="fa fa-remove"></i>
                                  </b-button>
                                </b-input-group-append>
                              </b-input-group>

                              <!-- && filter.options
                      :multiple="filter.multiple == true ? true : false" -->
                              <!-- v-model="mifield.args[mifield.key]" :placeholder="mifield.placeholder"-->
                              <treeselect v-if="mifield.type == 'listofvalues'" :show-count="true"
                                :flatten-search-results="true" :clearable="false" :disable-branch-nodes="true"
                                :matchKeys="['id']" search-nested :options="mifield.options" v-model="mifield.value">
                              </treeselect>

                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>

                  <div class="mt-0 mb-1 text-center">
                    <table class="w-100pct">
                      <tr class="header-dark mb-1">
                        <td role="columnheader" scope="col" aria-colindex="1"
                          class="table-b-table-default text-center w-25px" title="Click to select/unselect all">
                          <input id="travellersAll" style="height: 15px; margin-top: 2px" type="checkbox"
                            :checked="allTravellersChecked" @change="travellersAll"
                            :disabled="value.passengers.length == 1" />
                        </td>
                        <!-- colspan="2" -->
                        <td class="text-center w-50px">Travellers</td>
                        <td>Name</td>
                        <td><span v-if="mifields.length <= 0">Your Ref / PO</span></td>
                        <td @click="cliptickets()">Tickets <i @click="cliptickets()" :id="'ticket-copy_' + value.id"
                            class="fa fa-clipboard hover-primary" title="Copy"></i></td>
                        <b-tooltip :target="'ticket-copy_' + value.id" placement="top">Copy selected passenger's
                          ticketnos
                          to the clipboard</b-tooltip>
                      </tr>
                      <tr>
                        <td></td>
                        <!-- colspan="2" -->
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr v-for="(passenger, index) in value.passengers" :key="index">

                        <td class="w-30px">
                          <b-input-group class="m-auto w-15px">
                            <input id="travellerCheck" style="height: 13px" type="checkbox" v-model="travellers"
                              @click="toggleTraveller($event, index)" :checked="true" :value="passenger"
                              :disabled="value.passengers.length == 1" />
                          </b-input-group>
                        </td>
                        <td class="w-30px"> <span class="small text-primary">{{ index + 1 }}.</span></td>
                        <!-- <td class="w-30px"> <i class="fa fa-user text-primary mr-2"></i></td> -->
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="passenger.passenger" placeholder="Passenger" trim
                                :disabled="true"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td>
                          <b-form-group class="mb-3px" v-if="mifields.length <= 0">
                            <b-input-group>
                              <b-form-input size="sm" v-model="passenger.yourref" placeholder="P/O"
                                :formatter="onlyascii" trim></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="passenger.yourref = ''">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                                <b-button size="sm" variant="outline-secondary" title="Fill down"
                                  @click="fillPO($event, index)">
                                  <i class="fa fa-long-arrow-down text-primary"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td>
                          <span :id="'ticketno_tooltip' + ticket.ticketno" v-for="(ticket, index) in passenger.tickets"
                            :key="index">

                            <span class="small text-primary ml-1">{{ index + 1 }}.</span>
                            <i v-if="ticket.type == 'CHARTER' || ticket.type == 'TICKET' || ticket.type == 'REISSUE'"
                              :class="'fa fa-ticket text-orange'" :title="ticket.type"></i>
                            <i v-if="ticket.type == 'EMD'" :class="'fa fa-user-plus text-purple'"
                              :title="ticket.type"></i>
                            <span> {{ ticket.ticketno }}</span>
                            <b-tooltip :target="'ticketno_tooltip' + ticket.ticketno" placement="bottom">TicketNo: {{
                              ticket.ticketno }} <br> Type: {{ ticket.type }} <br> Issued: {{
                                $moment.unix(ticket.issued_at * .001).utc(true).format('DD/MM/YY HH:mm') }}</b-tooltip>
                          </span>
                        </td>

                      </tr>
                    </table>
                  </div>
                  <!-- } -->


                  <div class="mt-2 mb-1 text-center">
                    <table class="w-100pct">
                      <tr class="header-dark ">
                        <td role="columnheader" scope="col" aria-colindex="1"
                          class="table-b-table-default text-center w-25px">

                          <input id="segmentsAll" style="height: 15px; margin-top: 2px" type="checkbox"
                            :checked="allSegmentsChecked" @change="segmentsAll"
                            :disabled="value.sectors.length == 1 || value.sectors.filter(o => o.fare != 'N/A').length == 1" />
                        </td>
                        <!-- colspan="2"  -->
                        <td class="text-center w-50px">Sectors </td>
                        <td> SupType</td>
                        <td> Locator </td>
                        <td> Agent </td>
                        <td> Route </td>
                        <td> FlightNo </td>
                        <td> Depart </td>
                        <td> Arrive </td>
                        <td> Class </td>
                        <td> Cabin </td>
                        <td> Net GBP</td>
                        <td> Tax GBP</td>
                        <td> Total GBP </td>
                        <td> PP Markup GBP</td>
                      </tr>
                      <tr>
                        <td></td>
                        <!-- colspan="2" -->
                        <td></td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                        <td> </td>
                      </tr>
                      <tr v-for="(sector, index) in value.sectors" :key="index">

                        <td class="w-30px">
                          <b-input-group class="m-auto w-15px">
                            <input id="segmentCheck" style="height: 12px" type="checkbox" v-model="segments"
                              @click="toggleSegment($event, index)" :checked="true" :value="sector"
                              :disabled="value.sectors.length == 1 || sector.fare == 'N/A' || value.sectors.filter(o => o.fare != 'N/A').length == 1" />

                          </b-input-group>
                        </td>
                        <td class="w-30px">
                          <span class="small text-primary">{{ index + 1 }}.</span>
                        </td>
                        <!-- <td class="w-30px">
                          <i class="fa fa-plane text-primary mr-2"></i>
                        </td> -->

                        <td class="w-70px p-0">
                          <b-row>
                            <b-col>
                              <b-form-group class="mb-3px z-0">
                                <b-input-group>
                                  <button type="button" :id="'lines-type_' + sector.locator + sector.id"
                                    class="h-20px radius-0 pr-1 btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled="true">
                                    <span class="sr-only">Toggle Dropdown</span>
                                  </button>
                                  <b-button class="h-22px w-45px text-center"
                                    :id="'lines-faicon_' + sector.locator + sector.id" size="sm"
                                    variant="outline-secondary" @click="setType(index)" :disabled="false">
                                    <span class="border-right-light">{{suppliertype_options.find(o
                                      => o.id
                                      ==
                                      sector.type).id
                                    }} </span>
                                    <i :class="sector.type ? 'fa ' + suppliertype_options.find(o => o.id == sector.type).faicon : 'fa fa-exclamation-triangle text-danger'"
                                      class="font-14px w-20px pl-1"></i>
                                  </b-button>
                                  <b-tooltip :target="'lines-faicon_' + sector.locator + sector.id" placement="top">
                                    {{suppliertype_options.find(o => o.id ==
                                      sector.type).label
                                    }}</b-tooltip>
                                  <b-popover :target="'lines-type_' + sector.locator + sector.id"
                                    title="Select Supplier Type" triggers="focus" :placement="'lefttop'"
                                    custom-class="p-0">
                                    <p v-for="(faicon, aindex) in suppliertype_options" :key="aindex"
                                      class="text-left hover-pointer hover-highlight px-2 py-1 mb-0">
                                      <span @click="setType(index, faicon.id)">
                                        <i class="w-20px" :class="'fa ' + faicon.faicon"></i>{{
                                          faicon.label
                                        }}</span>
                                    </p>
                                  </b-popover>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </td>

                        <!-- <td class="w-70px">

                          <b-row>
                            <b-col>
                              <b-form-group class="mb-3px z-0">
                                <b-input-group>
                                  <b-input-group-prepend>
                                    <b-button class="h-22px w-30px" :id="'lines-faicon_' + sector.locator + sector.id"
                                      size="sm" variant="outline-secondary" @click="setType(index)" :disabled="false">
                                      <i :class="sector.type ? 'fa ' + suppliertype_options.find(o => o.id == sector.type).faicon : 'fa fa-exclamation-triangle text-danger'"
                                        class="font-14px padding-left:5px !important; margin-top:15px"></i>
                                    </b-button>
                                    <b-tooltip :target="'lines-faicon_' + sector.locator + sector.id" placement="top">
                                      {{suppliertype_options.find(o => o.id == sector.type).label}} </b-tooltip>

                                  </b-input-group-prepend>
                                  <b-dropdown split split-variant="outline-secondary" variant="secondary"
                                    :disabled="true" :text="sector.type ? sector.type : '*'" size="sm"
                                    class="h-22px dropdown-input" style="">
                                    <b-dropdown-item v-for="(faicon, aindex) in suppliertype_options" :key="aindex"
                                      href="#" :active="sector.type == faicon.id ? true : false"
                                      @click="setType(index, faicon.id)"><i :class="'fa ' + faicon.faicon"></i> {{
                                        faicon.label
                                      }}</b-dropdown-item>
                                  </b-dropdown>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>

                        </td> -->

                        <td>
                          <!-- <div class=" form-control form-control-sm disabled">{{
          $moment.unix(sector.issued_at * 0.001).utc(false).format('DD/MM/YY HH:mm') }}
                          </div> -->
                          <div class=" form-control form-control-sm disabled">{{ sector.locator }}
                          </div>
                        </td>

                        <td :id="'agentname_' + sector.id">
                          <div class="text-center form-control form-control-sm disabled">
                            {{ sector.agent }}</div>
                        </td>
                        <!-- <b-tooltip :target="'agentname_' + sector.id" placement="left">
                          {{ sector.agentname }}
                        </b-tooltip> -->
                        <td>
                          <div class=" form-control form-control-sm disabled">{{ sector.route
                          }}</div>

                        </td>
                        <td>
                          <div class=" form-control form-control-sm disabled">{{ sector.flightno
                          }}</div>

                        </td>
                        <td>
                          <div class=" form-control form-control-sm disabled">{{
                            $moment.unix(sector.start_at * .001).utc(false).format('dd DD/MM/YY HH:mm')
                          }}</div>

                        </td>
                        <td>
                          <div class=" form-control form-control-sm disabled">{{
                            $moment.unix(sector.end_at * .001).utc(false).format('dd DD/MM/YY HH:mm')
                          }}</div>

                        </td>
                        <td>
                          <div class=" form-control form-control-sm disabled">{{ sector.class
                          }}</div>

                        </td>
                        <!-- <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" class="text-center" v-model="sector.class"
                                :disabled="true"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td> -->
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" class="text-center" v-model="sector.cabin"
                                :disabled="true"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td>

                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="sector.fare" placeholder="Fare" class="text-right"
                                :disabled="true" trim></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="sector.tax" placeholder="Tax" class="text-right"
                                :disabled="true" :formatter="nocomma"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="sector.total" placeholder="Total" class="text-right"
                                :formatter="nocomma" :disabled="true"></b-form-input>
                              <!-- :disabled="sector.total == 'N/A' ? true : false" -->
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="sector.markup" placeholder="Markup" class="text-right"
                                :formatter="nocomma" :disabled="true"></b-form-input>
                              <!-- :disabled="sector.markup == 'N/A' ? true : false" -->
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="sector.markup = '0.00'"
                                  :disabled="true">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </td>
                      </tr>
                      <tr>
                        <td class="pl-1 text-left pt-1" colspan="10">
                          <b-row class="mt-2" no-gutters>
                            <b-col cols="auto" class="text-left">
                              <b-button size="sm" class="xs line-height-0" :variant="'outline-primary'" @click="saveit"
                                :disabled="value.posted">
                                Save It
                              </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                              <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                              </div>
                              <div v-else>
                                <span v-html="message_saveit"></span>
                              </div>
                            </b-col>
                          </b-row>

                        </td>

                        <td><span class="h6 strong">Total PP</span></td>
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="value.fare" placeholder="Net" class="text-right strong"
                                :disabled="true" :formatter="nocomma"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="value.tax" placeholder="Tax" class="text-right strong"
                                :disabled="true" :formatter="nocomma"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="value.total" placeholder="Total"
                                class="text-right strong" :disabled="true" :formatter="nocomma"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </td>
                        <td>
                          <b-form-group class="mb-3px">
                            <b-input-group>
                              <b-form-input size="sm" v-model="value.markup" placeholder="Markup"
                                class="text-right strong" :formatter="nocomma"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="value.markup = '0.00'">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </td>
                      </tr>
                      <tr v-if="1 == 0">
                        <td colspan="14" class="pr-1 text-right"><span class="h6 strong">Ticketing Fee</span></td>
                        <td>
                          <b-form-group>
                            <b-input-group>
                              <b-form-input size="sm" v-model="value.fee" placeholder="fee" class="text-right strong"
                                :formatter="nocomma"></b-form-input>
                              <b-input-group-append>
                                <b-button size="sm" variant="outline-secondary" @click="value.fee = '0.00'">
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </td>
                      </tr>
                    </table>
                  </div>

                </b-col>
              </b-row>
              <!-- {{ travellers }} -->
              <!-- {{ value.total }} -->
              <!-- {{ segments }} -->
              <!-- {{ value.tax }} -->
            </p>
          </b-tab>
          <b-tab>
            <template #title>
              <i class="fa fa-wpforms text-primary mr-1"></i> Draft
            </template>

            <p class="py-3 px-0">
            <div class="etr">
              <b-row>
                <b-col cols="12">
                  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
                    <r-invoice :showasdraft="true" :item="item" />
                    <b-alert v-if="item.message" show :variant="item.level" class="text-center mt-2 mb-1">
                      <b-row align-v="center" no-gutters class="font-13px"><b-col cols="auto mr-3">
                          <i class="fa fa-info-circle fa-2x"></i></b-col>
                        <b-col> <span v-html="item.message.split('\n').join('<br/>')"></span></b-col></b-row>
                    </b-alert>
                  </b-overlay>
                  <b-card-footer class="mt-2 ml-1">
                    <b-row>
                      <b-col class="text-left">
                        <b-row class="mt-1">
                          <b-col>
                            <div v-if="busy">
                              <i class="fa fa-spinner fa-spin text-primary"></i>
                              <span class="text-success ml-2">Preparing set of invoice(s)</span>
                            </div>
                            <div v-else>
                              <span v-html="message"></span>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="text-right">
                        <b-button-group class="z-0" v-if="items.length > 1">
                          <b-button squared size="sm" @click="render()" variant="outline-primary" class="mr-1 h-28px">
                            <i class="fa fa-refresh"></i>
                          </b-button>

                          <b-pagination hide-ellipsis v-model="page" :total-rows="items.length" :per-page="1"
                            align="right" size="sm"></b-pagination>
                        </b-button-group>


                      </b-col>

                    </b-row>

                  </b-card-footer>
                  <div v-if="showledgers" class="mx-4">
                    <b-row>
                      <b-card class="border-none w-100pct">
                        <b-card-title class="text-left">B/L Item Headers</b-card-title>
                        <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="data.BL"
                          :showpages="false" :showtoolbar="false">
                        </d-table>
                      </b-card>
                    </b-row>
                    <b-row>
                      <b-card class="border-none w-100pct">
                        <b-card-title class="text-left">S/L Item Headers</b-card-title>
                        <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="SL"
                          :showpages="false" :showtoolbar="false">
                        </d-table> </b-card></b-row>
                    <b-row>
                      <b-card class="border-none w-100pct">
                        <b-card-title class="text-left">l Item Lines</b-card-title>
                        <d-table classdivtable="availtable datatable" refid="blitemheaders" :items="data.SL[0].items"
                          :showpages="false" :showtoolbar="false">
                        </d-table> </b-card></b-row>
                  </div>
                </b-col>
              </b-row>
            </div>
            </p>
          </b-tab>

          <b-row v-if="value.eventcode == '*BLOCKED*'" class="px-0">
            <b-col>
              <b-alert :show="true" variant="danger">
                <b-row align-v="center" no-gutters class="font-13px"><b-col cols="auto mr-3">
                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                  <b-col>
                    Please add a valid eventcode.</b-col></b-row>
              </b-alert></b-col>
          </b-row>

          <b-row v-if="value.slac == '*BLOCKED*'" class="px-0">
            <b-col>
              <b-alert :show="true" variant="danger">
                <b-row align-v="center" no-gutters class="font-13px"><b-col cols="auto mr-3">
                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                  <b-col>
                    Please add a valid slac.</b-col></b-row>
              </b-alert></b-col>
          </b-row>

          <b-tab>
            <template #title>
              <div class="badgecontainer pr-1 mr-1">
                <i class="fa fa-comments-o text-primary mr-1"></i> Notes
                <b-badge id="notes" variant="danger" class="edit_tab" v-if="value.notes">
                  {{ value.notes ? '1' : '' }} </b-badge>
              </div>



            </template>
            <p>
              <b-row class="mt-2">
                <b-col cols="12">
                  <b-form-group label="Notes" label-for="notes" label-cols="12">
                    <b-input-group class="treeselect_all pr-2px">
                      <span style="padding-top: 0.3em; padding-left:32px" id="notes-tooltip">
                        <i class="fa fa-info-circle text-black"></i></span>
                      <b-tooltip target="notes-tooltip" triggers="hover" placement="bottom">Please
                        let us know below
                        the reason if you are delaying the invoicing e.g. waiting for PO,
                        waiting for
                        next statement etc.
                      </b-tooltip>

                    </b-input-group>
                    <b-form-textarea id="notes" v-model="value.notes" placeholder="Reason for not invoicing?" rows="10"
                      max-rows="10" class="smalltextarea courier"></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="mt-1">
                <b-col cols="auto">
                  <b-button-group class="z-0">
                    <b-button size="sm" class="xs line-height-0" :variant="'outline-primary'" @click="saveit"
                      :disabled="value.posted">
                      Save It
                    </b-button>
                    <b-button size="sm" variant="outline-primary" class="xs line-height-0 ml-1" @click="timestamp">
                      <i class="fa fa-comment-o" style="margin:-1px;"></i>
                      Add Notes
                    </b-button>
                  </b-button-group>
                </b-col>
                <b-col class="text-left ml-0 mt-0">
                  <div v-if="busy">
                    <i class="fa fa-spinner fa-spin text-primary"></i>
                  </div>
                  <div v-else>
                    <span v-html="message_saveit"></span>
                  </div>
                </b-col>
              </b-row>


            </p>
          </b-tab>

          <b-tab v-if="value.cssname == 'zhold_fee' || value.cssname == 'zhold_priced'">
            <template #title>
              <div class="badgecontainer pr-1 mr-1">
                <i class="fa fa-android text-primary "></i> Robot
                <b-badge id="robot" variant="danger" class="edit_tab" v-if="value.robot">
                  {{ value.robot ? '1' : '' }} </b-badge>
              </div>



            </template>
            <p>
              <!-- {{ value.id + 'robot-tooltip' }} -->
              <b-row class="mt-2">
                <b-col cols="12">
                  <b-form-group label="Robot" label-for="robot" label-cols="12">
                    <b-input-group class="treeselect_all pr-2px">
                      <span style="padding-top: 0.3em; padding-left:32px" :id="value.id + '_robot-tooltip'">
                        <i class="fa fa-info-circle text-black"></i></span>
                      <b-tooltip :target="value.id + '_robot-tooltip'" triggers="hover" placement="bottom">The last time
                        this
                        tried to invoice automatically it failed.
                        The reason is shown below. To clear this ticket please invoice manually.
                      </b-tooltip>
                    </b-input-group>
                    <b-form-textarea id="robot" v-model="value.robot"
                      placeholder="These tickets will be invoiced automatically at 21:30 this evening." rows="10"
                      max-rows="10" class="smalltextarea courier" disabled="readonly"></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </p>
          </b-tab>

        </b-tabs>

      </b-card-body>

      <!-- queued={{ value.queued }} -->

      <!-- <b-row class="px-1">
        <b-col cols="auto" class="text-left mb-2">
          <b-button squared size="sm" :variant="'outline-primary'" @click="saveit" :disabled="value.posted">
            <i class="fa fa-check"></i>
            Save It
          </b-button>
        </b-col>
      </b-row> -->

      <template #footer>
        <b-row class="mx-n4">
          <b-col cols="auto" class="text-left">
            <!-- <b-button squared size="sm" :variant="'outline-primary'" @click="saveit" :disabled="value.posted">
              <i class="fa fa-check"></i>
              Save It
            </b-button> -->
            <b-button v-if="!draft && !blocked" squared size="sm" :variant="busy ? 'warning' : 'primary'"
              :disabled="busy || value.queued || travellers.length == 0 || segments.length == 0" @click="queueit">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-white mr-1"></i>
                <span class="text-white" v-html="'Sending To Invoice Queue'"></span>
              </div>
              <div v-else>
                <i :class="value.queued ? 'fa fa-stack-overflow mr-1' : 'fa fa-paper-plane mr-1'"></i>
                <span v-html="value.queued ? 'Queued' : 'Send To Invoice Queue'"></span>
              </div>
            </b-button>
          </b-col>
          <b-col align-self="center"><span v-if="!value.queued && !busy && !draft && !blocked"
              v-html="readymessage"></span> </b-col>
          <b-col cols="auto">
            <b-row>
              <b-col cols="auto" align-self="center">
                <h5 :class="ZColour">
                  {{ ZTotal }}
                </h5>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>

    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "zinput",
  data() {
    return {
      tabindex: 0,
      message: "",
      message_saveit: "",
      message_postit: "",
      busy: false,
      draft: false,
      notes: null,
      travellers: [],
      segments: [],
      page: 1,
      level: ["success"],
      ss: [],
      items: [],
      item: {
        ref: ""
      },
      data: null,
      SL: [],
      showledgers: false,
      level: ["success"],
      options_level: [
        { id: "success", label: "Success" },
        { id: "warning", label: "Warning" },
        { id: "danger", label: "Danger" },
      ],
      suppliertype_options: [],
    };
  },
  async mounted() {
    try {
      const response = await this.$apollo.query({
        query: gql`
                        query suppliertypes {
                        suppliertypes {
                            id
                            label
                            faicon
                        }
                        }
                    `,
      });
      this.suppliertype_options = response.data.suppliertypes.filter(o => o.faicon != '');
    } catch (error) {
      console.log(error);
    }
    // await this.load_agents()
  },
  props: {
    value: { type: Object, required: true },
    title: { type: String, default: "" },
  },
  computed: {
    message_postit() {
      return (
        "<span class='text-primary'>Posted it.</span>"
      );
    },
    readymessage() {
      return (
        "<span class='text-primary'>Ready to submit " +
        this.invoicecount +
        " invoice(s).</span>"
      );
    },
    blocked() {
      if (this.value.eventcode == "*BLOCKED*" || this.value.slac == "*BLOCKED*" || parseFloat(this.value.markup) < 0) {
        return true
      } else {
        return false
      }
    },
    invoicecount() {
      let count = 1;
      if (this.value.passengers) {
        let yourrefs = [
          ...new Set(
            this.value.passengers.map((item) =>
              item.yourref ? item.yourref : null
            )
          ),
        ];
        count = yourrefs.length;
      }
      return count;
    },
    ZTotal() {
      let sell = 0.0;
      let tax = 0
      for (var i = 0; i < this.segments.length; i++) {
        if (this.segments[i].fare != "N/A") {
          sell += parseFloat(this.segments[i].fare);
        }
        if (this.segments[i].tax != "N/A") {
          tax += parseFloat(this.segments[i].tax);
        }
      }
      this.value.total = (sell + tax).toFixed(2)
      this.value.fare = sell.toFixed(2)
      this.value.tax = tax.toFixed(2)


      if (parseFloat(this.value.markup)) {
        sell += parseFloat(this.value.markup);
      }

      let total = this.travellers.length * (sell + tax)
      if (parseFloat(this.value.fee)) {
        total += this.travellers.length * parseFloat(this.value.fee)
      }


      return (
        // this.travellers.length + " pax * ( " + sell.toFixed(2) + " + " + tax.toFixed(2) + " = " + (sell + tax).toFixed(2) + " PP ) + " + this.value.fee + " (fee) = GBP " +
        this.travellers.length + " pax * ( " + sell.toFixed(2) + " + " + tax.toFixed(2) + " = " + (sell + tax).toFixed(2) + " PP ) = GBP " +
        total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    },
    ZColour() {
      let result = "text-danger"
      if (parseFloat(this.value.markup) > 0) {
        result = "text-primary"
      }
      result += " strong mb-0"
      return result
    },
    allTravellersChecked() {
      const checked = this.travellers.length;
      // // console.log("allAreChecked?", checked);
      return checked === this.value.passengers.length
      // return true
    },
    allSegmentsChecked() {
      const checked = this.segments.length;
      // // console.log("allAreChecked?", checked);
      return checked === this.value.sectors.length
    }
  },
  watch: {
    tabindex: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal == 1) {
          await this.renderit()
        }
      }
    },
    value: {
      immediate: true,
      async handler(newVal, oldVal) {
        this.travellers = newVal.passengers
        this.segments = newVal.sectors

        this.item.tags = newVal.tags ? newVal.tags : "{}";

        // THIS COPIES OVER THE PO REFERENCE TO TAGS MI_P IF MISSING
        if (this.item.tags) {
          let tags = JSON.parse(this.item.tags);
          if (!tags.mi_P && newVal.passengers[0].yourref) {
            tags.mi_P = newVal.passengers[0].yourref;
            this.item.tags = JSON.stringify(tags);
          }
        }
        
        this.item.slac = newVal.slac
        this.item.stype = newVal.sectors[0].type

        await this.load_mifields()

        this.tabindex = 0
        this.message_saveit = ""
      }
    },
    page: {
      async handler(newVal, oldVal) {
        if (newVal) {
          if (newVal <= this.ss.length) {
            this.item = this.ss[newVal - 1];

            if (this.item.data) {
              this.data = JSON.parse(this.item.data);
              this.SL = [];
              this.SL.push({ ...this.data.SL[0] });
              delete this.SL[0].items;
            }
          }
        }
      },
    }
  },
  methods: {
    zhold_type(value) {
      switch (value) {
        case "zhold_fee":
          return "Fee";
        case "zhold_priced":
          return "Priced";
        default:
          return "";
      }
    },
    onlyascii(value) {
      // A SPECIFIC REPLACE
      value = value.split('b').join('')
      value = value.normalize('NFD').replace(/([\u0300-\u036f]|[^\x20-\x7E])/g, '')
      return value
    },
    cliptickets() {
      let alltickets = []
      for (var i = 0; i < this.value.passengers.length; i++) {
        let found = this.travellers.find(o => o.passenger == this.value.passengers[i].passenger)
        if (found) {
          alltickets = alltickets.concat(found.tickets)
        }
      }
      try {
        window.navigator.clipboard.writeText(alltickets.map(q => q.ticketno).join(","));
      } catch (error) {
        console.log(error)
      }
    },
    travellersAll(evt) {
      const list = this.allTravellersChecked
        ? []
        : this.value.passengers.slice(0, this.value.passengers.length);
      this.travellers = list;
    },
    toggleTraveller(evt, index) {
      console.log("toggleTraveller", evt, index);

      const savedIndex = this.savedIndex;
      this.savedIndex = index;

      // If this is the first pass or no shift key was
      // pressed, just bail.
      if (savedIndex === null || !evt.shiftKey) return;

      // Shift-clicked the same message :-/
      if (index === savedIndex) return;

      // Get the subset of the message list between the
      // two indicies.
      // console.time("toggle range");
      const subset = this.items.slice(
        Math.min(index, savedIndex),
        Math.max(index, savedIndex) + 1
      );
      // Determine the operation based on the checked state
      // of the clicked checkbox.
      const toggleFn = evt.currentTarget.checked
        ? addCheckedSubset
        : removeCheckedSubset;

      this.travellers = toggleFn(this.travellers, subset);
      console.log("these are checked", this.travellers);
      // console.timeEnd("toggle range");
    },
    segmentsAll(evt) {
      const list = this.allSegmentsChecked
        ? []
        : this.value.sectors.slice(0, this.value.sectors.length);
      this.segments = list;
    },
    toggleSegment(evt, index) {
      console.log("toggleSegment", evt, index);

      const savedIndex = this.savedIndex;
      this.savedIndex = index;

      // If this is the first pass or no shift key was
      // pressed, just bail.
      if (savedIndex === null || !evt.shiftKey) return;

      // Shift-clicked the same message :-/
      if (index === savedIndex) return;

      // Get the subset of the message list between the
      // two indicies.
      // console.time("toggle range");
      const subset = this.items.slice(
        Math.min(index, savedIndex),
        Math.max(index, savedIndex) + 1
      );
      // Determine the operation based on the checked state
      // of the clicked checkbox.
      const toggleFn = evt.currentTarget.checked
        ? addCheckedSubset
        : removeCheckedSubset;

      this.segments = toggleFn(this.segments, subset);
      console.log("these are checked", this.segments);
      // console.timeEnd("toggle range");
    },
    fillPO(evt, index) {
      console.log("fillPO", evt, index);
      let yourref = ""
      for (var i = 0; i < this.value.passengers.length; i++) {
        if (i == index) {
          yourref = this.value.passengers[i].yourref
        }
        if (i > index) {
          let found = this.travellers.find(o => o.passenger == this.value.passengers[i].passenger)
          if (found) {
            this.value.passengers[i].yourref = yourref
          }
        }
      }
    },

    async timestamp() {
      if (!this.value.notes) { this.value.notes = "" }
      this.value.notes +=
        this.$moment().format("DD/MM/YY HH:mm") +
        " " +
        this.user.initials +
        "\n";
    },
    async saveit() {
      //  this.busy = true;
      console.log('saveit')

      let tags = this.item.tags == null ? {} : JSON.parse(this.item.tags)
      if (this.mifields.length > 0) {
        for (var k = 0; k < this.mifields.length; k++) {
          tags[this.mifields[k].key] = this.mifields[k].value;
        }
      }

      let requirements = await this.mifields_requirement()
      if (requirements.length > 0) {
        this.message_saveit =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        this.busy = false;
        return;
      } else {
        this.message_saveit = ""
      }

      let rows = []
      for (var i = 0; i < this.value.passengers.length; i++) {
        let passenger = this.value.passengers[i]
        if (tags.mi_P) {
          passenger.yourref = tags.mi_P
        }
        for (var j = 0; j < passenger.tickets.length; j++) {
          let ticket = passenger.tickets[j]
          let found = rows.find(o => o.id == ticket.id)
          if (!found) {
            rows.push({ id: this.value.passengers[i].tickets[j].id })
          }
        }

      }

      for (var i = 0; i < rows.length; i++) {
        let row = rows[i]

        if (this.value.slac) {
          row.slac = this.value.slac
        }
        if (this.value.eventcode) {
          row.eventcode = this.value.eventcode
        }
        if (this.value.notes) {
          row.notes = this.value.notes
        }
        if (tags) {
          row.tags = JSON.stringify(tags)
        }
      }

      let variables = {
        rows
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation tickets_save(
              $rows: [Ticket_input]           
            ) {
              tickets_save(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });

        this.message_saveit = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message_saveit = "<span class='text-danger'>" + error.message + "</span>";
      }

    },
    async renderit() {

      console.log('renderit')
      this.busy = true
      this.draft = true

      let tags = this.item.tags == null ? {} : JSON.parse(this.item.tags)
      if (this.mifields.length > 0) {
        for (var k = 0; k < this.mifields.length; k++) {
          tags[this.mifields[k].key] = this.mifields[k].value;
        }
      }

      let quote = { ... this.value }
      quote.tags = this.item.tags;
      quote.passengers = this.travellers
      if (tags.mi_P) {
        quote.passengers = quote.passengers.map(e => ({...e, yourref: tags.mi_P}));
      }
      quote.sectors = this.segments.filter(o => o.fare != 'N/A')

      let variables = {
        data: JSON.stringify(quote),
        apply: false
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query zhold_draftinvoice(
                $data: String
                $apply: Boolean
            ) {
              zhold_draftinvoice(
                data: $data
                    apply: $apply
                ) {
                  ref
                  to
                  address
                  dateref
                  slac
                  agent
                  yourref
                  eventname
                  vatregion
                  saletotal
                  terms
                  credit
                  id
                  data
                  mifields {
                    label
                    value
                  }
                  document {
                    fields {
                      key
                      label
                      class
                    }
                    items
                  }
                  message
                  level
                }
            }
            `,
          variables,
          fetchPolicy: "no-cache",
        });

        this.items = response.data.zhold_draftinvoice;
        let sset = this.items
        this.ss = sset

        this.item = { ref: "" }
        if (this.ss.length > 0) {

          this.item = this.ss[0];
          this.SL = []

          if (this.item.data) {
            this.data = JSON.parse(this.item.data);
            this.SL.push({ ...this.data.SL[0] });
            delete this.SL[0].items;
          }
        }

      } catch (error) {
        console.log(error);
      }
      this.draft = false
      this.busy = false
    },
    async queueit() {
      console.log('queueit', this.value)

      let tags = this.item.tags == null ? {} : JSON.parse(this.item.tags)
      if (this.mifields.length > 0) {
        for (var k = 0; k < this.mifields.length; k++) {
          tags[this.mifields[k].key] = this.mifields[k].value;
        }
      }

      let requirements = await this.mifields_requirement()
      if (requirements.length > 0) {
        this.message_saveit =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        this.busy = false;
        return;
      } else {
        this.message_saveit = ""
      }

      this.busy = true;

      await this.saveit()

      let quote = { ... this.value }
      quote.tags = this.item.tags;
      quote.passengers = this.travellers
      quote.sectors = this.segments.filter(o => o.fare != 'N/A')

      let variables = {
        data: JSON.stringify(quote),
        apply: true
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query zhold_draftinvoice(
                $data: String
                $apply: Boolean

            ) {
              zhold_draftinvoice(
                data: $data
                apply: $apply
                ) {
                  ref
                  to
                  address
                  dateref
                  slac
                  agent
                  yourref
                  eventname
                  vatregion
                  saletotal
                  terms
                  credit
                  id
                  data
                  document {
                    fields {
                      key
                      label
                      class
                    }
                    items
                  }
                  message
                  level
                }
            }
            `,
          variables,
          fetchPolicy: "no-cache",
        });

      } catch (error) {
        console.log(error);
      }
      this.$emit("queueit");

      this.items = []
      this.ss = []
      this.busy = false;
    }
  }
};
</script>

<style></style>